import React from "react";
import { useAppSelector, useAppDispatch } from "../redux";
import { sessionActions } from "../redux/reducers/sessionSlice";
import { useEffectiveOrganization } from "../hooks/useEffectiveOrganization";
import { View, Text, Button } from "./base";
import { Icon } from "./base/Icon";
import { Container, Badge } from "./base";

export const OrganizationContextIndicator = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.session.user);
  const { organization, isUsingSelectedOrg } = useEffectiveOrganization();

  // Get user's actual organization
  const userOrganization = useAppSelector((state) => (user?.organizationId ? state.organization.entities[user.organizationId] : null));

  // Only show if user is admin and viewing a different organization
  if (!user?.isAdmin || !isUsingSelectedOrg || !organization || !userOrganization) {
    return null;
  }

  const handleSwitchToMyOrg = () => {
    // Clear selected organization to return to user's actual org
    dispatch(sessionActions.setSelectedOrganization(null));
    window.location.reload();
  };

  return (
    <View className="bg-teal-50 dark:bg-teal-900/30 border-b border-teal-200 dark:border-teal-700 py-3">
      <Container
        size="xl"
        className="flex items-center justify-between"
      >
        <View className="flex items-center space-x-3">
          <Icon
            name="admin_panel_settings"
            size={16}
            className="text-teal-600 dark:text-teal-300"
          />
          <Text className="text-sm text-teal-800 dark:text-teal-100">
            <Badge
              variant="brand"
              className="mr-2"
            >
              Admin Mode
            </Badge>
            Currently viewing <span className="font-semibold">{organization.name}</span>
          </Text>
        </View>

        <View className="flex items-center space-x-3">
          <Text className="text-xs text-teal-700 dark:text-teal-200">
            Your organization: <span className="font-medium">{userOrganization.name}</span>
          </Text>
          <Button
            type="button"
            variant="ghost"
            onClick={handleSwitchToMyOrg}
            className="text-xs px-3 py-1 h-auto bg-teal-100 dark:bg-teal-800/60 text-teal-800 dark:!text-teal-100 hover:bg-teal-200 dark:hover:bg-teal-700/80 border border-teal-300 dark:border-teal-600 rounded-xl"
          >
            <Icon
              name="home"
              size={12}
              className="mr-1"
            />
            Switch to My Org
          </Button>
        </View>
      </Container>
    </View>
  );
};
